import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import UserFamilyMemberInvitation from './UserFamilyMemberInvitation';

loadDOMComponent({
	selector: 'react-user-family-member-invitation',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const userId = container.getAttribute('userId');
		const allowEdit = container.getAttribute('allowEdit');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<UserFamilyMemberInvitation userId={userId} allowEdit={allowEdit} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
